<template>
    <component :is="componentLoader" v-bind="params"></component>
</template>

<script>
    import AppHelper from "../helper";

    export default {
        props: {
            namespace: {default: 'pages'},
            module: {default: 'Home'},
            view: {default: 'Index'},
            id: {default: ''}
        },

        computed: {
            params() {
                let params = this.$route.params

                if(AppHelper.empty(params['namespace'])){
                    params['namespace'] = 'pages'
                }

                return params
            },

            componentLoader() {
                return AppHelper.lazyImport(this.params.view, this.params.namespace, this.params.module)
            }
        },

        watch: {
            '$route' (to, from) {
                this.componentLoader()
            }
        }
    }
</script>

<style scoped>

</style>